<template>
    <div v-if="isLoggedIn && comp" class="container page">


        <section v-if="!comp.isEnabled">
            <div class="alert alert-info">Competition not currently running</div>

        </section>
        <section v-else>
            <template v-if="displayPart==1">
                <div class="text-right"><a href="#" v-on:click.prevent="formReset">Reset</a></div>

            </template>



            <section v-if="displayPart==0" class="card card-default">
                <div class="card-header">
                    <h5>{{comp.title}}</h5>
                    <div>{{comp.description}}</div>
                </div>
                <div class="card-body">
                    <div><strong>Selected Employees to Nominate:</strong></div>
                    <div v-for="r in selectedMembers" :key="r._rowNum" class="row">
                        <template v-if="r.isEntireDivision">
                            <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                            <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                        </template>
                        <template v-else>
                            <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                            <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                            <div class="col">{{ r.division }}</div>
                        </template>
                    </div>
                    <div class="mt-1">
                        <b-button type="button" pill @click="$bvModal.show('modalChooseMembers')" variant="primary" size="sm" class="mt-2">{{selectedMembers.length===0 ? 'Select' : 'Change'}}  Recipient</b-button>
                        <b-form-invalid-feedback :state="formState.members">{{ formErrors.members }}</b-form-invalid-feedback>
                        <!--<a href="#" @click.prevent="$bvModal.show('modalChooseMembers')">Select Members</a>-->
                    </div>


                    <hr />
                    <b-form @submit.prevent="onSubmitNom" novalidate>

                        <!--<b-form-group v-if="false" id="groupAwardCategory" label-for="selectNomCat" label="Company Value:" :invalid-feedback="formErrors.nomCat" :state="formState.nomCat" description="Select one or more values" v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group id="selectNomCat" v-model="form.nomCat" :options="nomCatList" value-field="nomCatValue" text-field="nomCat" :state="formState.nomCat"
                                                   :aria-describedby="ariaDescribedby"
                                                   name="selectNomCat"></b-form-checkbox-group>
                        </b-form-group>-->


                        <b-form-group id="groupReason" label-for="txtMessage" :label="comp.textboxTitle" :invalid-feedback="formErrors.reason" :description="'(' + (750-form.reason.length) + ' characters remaining)'">
                            <b-form-textarea id="txtReason" v-model="form.reason" :state="formState.reason" :placeholder="comp.textboxDescription" rows="3" max-rows="5" maxlength="750" />
                        </b-form-group>
                        <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                    </b-form>
                </div>
            </section>
        </section>

        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Members -->
        <b-modal id="modalChooseMembers" title="Select Members" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Choose who to nominate"
                           selectedTitle="Recipients"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedMembers"
                           :isAllowWholeDivision="false"
                           :isSingle="false"
                           :showContinue="false"
                           class="mb-3" />
           
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseMembers')">Done</b-button></div>
        </b-modal>


    </div>



</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    //import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';
    // import SitecodeImage from '@/components/SitecodeImage';


    export default {
        name: 'Nominate',
        components: { MemberSelect },
        data() {
            return {
                comp: null,
                displayPart: 0,
                formInit: {},
                //form: { nomCat: [], reason: '', members: [] },
                form: { nomCat: '', reason: '', members: [] }, //nomCat is the competition title
                formErrors: {},
                formState: {},


                selectedMembers: [],
                nomCatList: [],
                nomCatList2: []

            }
        },
        computed: {
            isLoggedIn() {
                return this.$store.state.isLoggedIn
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            //reasonDescription() {
            //    const valueDesc = "Provide a reason - Your nomination and reason should reference the values you’re nominating the person/team for, with clear and concise examples or stories which illustrate that value. The three most important things to remember when writing a nomination are: What did the nominee do? How did they do it? What were the results or the impact?” The reason will be displayed on the e-card sent to your nominated employee.";
            //    const otherDesc = "Provide a reason - The three most important things to remember when writing a nomination are: What did the nominee do? How did they do it? What were the results or the impact?” The reason will be displayed on the e-card sent to your nominated employee.";

            //    return this.form.nomCat.includes("1Up nomination") || this.form.nomCat.includes("Service Excellence") ? otherDesc : valueDesc;
            //}
        },
        created() {
            this.formInit = { ...this.form }; //Create a copy of the form init values, so we can use this to reset the form
            //Integrity, Teamwork, Diversity, Innovation, Accountability, Excellence
            //this.nomCatList = [
            //    //{ nomCatValue: null, nomCat: '-- Please select a Value --', disabled: true },
            //    { nomCatValue: 'Integrity', nomCat: 'Integrity' },
            //    { nomCatValue: 'Teamwork', nomCat: 'Teamwork' },
            //    { nomCatValue: 'Diversity', nomCat: 'Diversity' },
            //    { nomCatValue: 'Innovation', nomCat: 'Innovation' },
            //    { nomCatValue: 'Accountability', nomCat: 'Accountability' },
            //    { nomCatValue: 'Excellence', nomCat: 'Excellence' },
            //]
            //this.nomCatList2 = [
            //    //{ nomCatValue: null, nomCat: '-- Please select a Value --', disabled: true },
            //    { nomCatValue: '1Up nomination', nomCat: '1Up nomination' },
            //    { nomCatValue: 'Service Excellence', nomCat: 'Service Excellence' },
            //]

            this.preSelectMemberLinkIn();


            this.$store
                .dispatch('getDivisionList', {})
                .then(() => {

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occurred: ' + JSON.stringify(error.response.data)));
                })
        },

        mounted() {
            this.formStateUpdate(true);


            axios.post('/api/competition/admincompetitionget', {})
                .then(({ data }) => {
                    this.comp = data.competition;
                })
                .catch((error) => {
                    if (error) {
                        this.msgBox('Error retrieving competition data');
                    }
                })

        },
        //watch: {
        //    memberClusterCode(val) {
        //        if (this.nomCatList.length === 0 && val !== null) this.getNomCats();
        //    },
        //},
        methods: {

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            formReset() {
                this.form = { ...this.formInit };
                this.displayPart = 0;
                this.selectedMembers = [];
            },

            formStateUpdate(init) {

                var fields = Object.getOwnPropertyNames(this.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (init) {
                        this.formState[field] = null;
                        this.formErrors = {}; //reset formErrors object
                    } else if (typeof this.formErrors[field] === 'undefined' || this.formErrors[field] === '') {
                        this.formState[field] = true;
                        console.log("field: " + field + " " + JSON.stringify(this.formState[field]));
                    } else {
                        this.formState[field] = false;
                        console.log("field: " + field + " false");
                    }
                }
            },

            preSelectMemberLinkIn() {
                //Add member to selected list, if passed in on sessionStorage (tloid)
                let tloidMemberId = sessionStorage.getItem('tloid'); //tloid - temp link out id - i.e. MemberId
                if (tloidMemberId) {
                    sessionStorage.removeItem('tloid');
                    axios.post('/api/site/getmemberget', { memberId: tloidMemberId })
                        .then(({ data }) => {
                            this.selectedMembers.push({
                                _serialNo: -1,
                                division: data.companyName,
                                firstname: data.firstName,
                                surname: data.surname,
                                isManager: false,
                                memberId: data.memberId,
                                memberNumber: data.memberNumber,
                                isEntireDivision: false,
                                entireDivisionCode: ''
                            });
                        })
                        .catch((error) => {
                            if (error) {
                                this.msgBox('Error retrieving member data');
                            }
                        })
                }
            },

            onSubmitNom() {
                this.form.members = this.selectedMembers.map(nominee => nominee.isEntireDivision ? 'div:' + nominee.entireDivisionCode : nominee.memberId)

                this.formStateUpdate(true);
                this.form.nomCat = this.comp.title;
                return axios
                    .post(
                        '/api/competition/newnom',
                        this.form
                    )
                    .then(() => {
                        this.formReset();
                        this.msgBox('Successfully submitted nomination');
                    })
                    .catch((error) => {
                        if (typeof error === 'undefined') return;
                        console.log('sj_error in competition.onSubmitNom() - ' + JSON.stringify(error));
                        this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occurred: ' + JSON.stringify(error.response.data)));
                        if (error.response.data.formErrors) {
                            this.formErrors = error.response.data.formErrors;
                            this.formStateUpdate(false);
                        }
                    })
                    ;
            }
        }


    }
</script>
